import { Currency } from "dinero.js";
import { useTheme } from "src/hooks/useTheme";
import { D } from "src/utils/helpers";

export const RoundedBar = (props: any) => {
  const { fill, x, y, width, height } = props;
  const radius = 5; // Adjust the border-radius as needed

  if (height < 0) {
    return (
      <g>
        <rect
          x={x}
          y={y + height}
          onClick={() => {
            if (props.onClick) {
              props.onClick();
            }
          }}
          width={width}
          height={-height}
          fill={fill}
          // only do the bottom right and bottom left radius
          rx={radius}
          ry={radius}
          style={{ cursor: "pointer", transition: "opacity 0.3s" }}
        />
      </g>
    );
  }

  return (
    <g>
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        onClick={() => {
          if (props.onClick) {
            props.onClick();
          }
        }}
        fill={fill}
        rx={radius}
        ry={radius}
        style={{ cursor: "pointer", transition: "opacity 0.3s" }}
      />
    </g>
  );
};

export const CustomTooltip = ({
  active,
  payload,
  label,
  field,
  currency,
}: {
  active?: boolean;
  payload?: any;
  label?: string;
  field: string;
  currency: Currency;
}) => {
  const theme = useTheme();

  if (active && payload && payload.length) {
    const value = ((payload || [])[0]?.payload?._data || {})[field];
    // const numTxns = (payload || [])[0]?.payload?._data?.numberOfTransactions;

    return (
      <div
        style={{
          padding: "5px 15px",
          background: theme.header,
          borderRadius: 100,
        }}
      >
        <p style={{ color: theme.background, fontWeight: 500, fontSize: 16 }}>
          <b>{label}: </b>
          {value || D(payload[0].value * 100, currency || "USD").toFormat()}
        </p>
      </div>
    );
  }
  return null;
};
